<template>
  <v-layout justify-center>
    <v-flex md8 xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <quill-editor
            class="mt-3 elevation-2"
            v-model="event.agenda"
            :options="editorOption"
            :disabled="!editable"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

var toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],

  ['clean'], // remove formatting button
  ['link'],
]

export default {
  props: ['editable', 'event'],

  components: { quillEditor },

  data() {
    return {
      editorOption: {
        placeholder: this.$t('labels.agenda'),
        modules: {
          toolbar: toolbarOptions,
        },
      },
    }
  },
}
</script>

<style scoped>
.quill-editor {
  background-color: #ffffff;
}

.quill-editor >>> .ql-editor {
  min-height: 350px;
}

.quill-editor >>> .ql-container {
  border: none;
  margin: 20px;
}

.quill-editor >>> .ql-toolbar {
  background-color: #f5f5f5;
  border: none;
  min-height: 48px;
  /* display: flex; */
  /* align-items: center; */
  padding-left: 24px;
}
</style>
